import { AstNodeType, FieldTypeCategory } from '@thinkalpha/language-services';
import type { ParserResult } from '@thinkalpha/language-services';

// eslint-disable-next-line @typescript-eslint/consistent-type-exports -- re-export
export * from './types';

/**
 * Analyzer that flags formula shapes the backtest compiler cannot render. Tracks every
 * `BacktestCompilationErrorCode` the compiler can throw — keep it in sync with the compiler
 * at `platform-ws/projects/api/src/services/backtest/compiler/`.
 *
 * Must be appended *after* the dictionary analyzer so call nodes' `functionDef` is resolved.
 *
 * Intentionally not surfaced (no client-side AST shape can reach them):
 * `backtest_constant_type_unsupported`, `backtest_match_expression_empty`,
 * `backtest_unary_operator_unsupported`, `backtest_unknown_ast_node`,
 * `backtest_unsupported_period`, `backtest_function_definition_not_dictionary`.
 */
export { backtestAnalyzer, BACKTEST_ANALYZER_SOURCE } from './backtestAnalyzer';

export function fakeConstStringParserResult<TExtraData extends object | undefined = any>(
    text: string,
    extraData?: TExtraData,
): ParserResult & { extraData: TExtraData | undefined } {
    return {
        errors: [],
        extraData,
        valid: true,
        text,
        root: {
            type: AstNodeType.const,
            path: '',
            errors: [],
            ranges: {
                node: { start: 0, end: text.length },
                value: { start: 0, end: text.length },
            },
            value: text,
            valid: true,
            warnings: [],
            dataType: FieldTypeCategory.String,
        },
        warnings: [],
    };
}
